import { useState } from "react";
import { Box, Button, Grid, Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
// import { SUB_REPORT_DATA } from "./reportData";
import { REPORT_DATA } from "./reportData";

export default function SubReport({ selectedReport }: { selectedReport: any }) {
  const dispatch = useDispatch();

  const pStyle: any = {
    fontSize: "24px",
    width: "100%",
    textAlign: "center",
    height: "35%",
  };

  const bStyle = {
    width: "100%",
    border: "1px solid #b7b6b6c4",
    borderRadius: "0 60px",
    height: "27vh",
    "&:hover": { transform: "scale(1.05)" },
    transition: "all 0.3s ease-in-out",
    cursor: "pointer",
    color: "#000",
    alignItems: "center",
  };

  const imgStyle = {
    width: "25%",
    display: "block",
    margin: "auto",
    opacity: "0.5",
    height: "65%",
  };

  return (
    <>
      <Grid container spacing={5} p={4} sx={{ direction: "ltr" }}>
        {REPORT_DATA[selectedReport - 1].items?.map((s) => (
          <Grid item xs={10} md={4}>
            <Link to={`/report/${selectedReport}_${s.value}`} style={{ textDecoration: "none" }} target="_blank">
              <Stack sx={bStyle}>
                {" "}
                <img src={s.src} alt="sub-report" style={imgStyle} />
                {s.text ? <p style={pStyle}>{s.text}</p> : null}
              </Stack>
            </Link>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
